import { render, staticRenderFns } from "./technicalSupport.vue?vue&type=template&id=63d3a7bd&scoped=true&"
import script from "./technicalSupport.vue?vue&type=script&lang=js&"
export * from "./technicalSupport.vue?vue&type=script&lang=js&"
import style0 from "./technicalSupport.vue?vue&type=style&index=0&id=63d3a7bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3a7bd",
  null
  
)

export default component.exports